import { selectTotalCategories } from '../api';
import { useHeaderData } from '../hooks';
import { CategoryLink } from './CategoryLink';

export function NavigationBar() {
  const data = useHeaderData();
  const totalCategories = selectTotalCategories(data);

  return (
    <nav className="tlw-hidden lg:tlw-block xl:tlw-absolute xl:tlw-left-1/2 xl:-tlw-translate-x-1/2">
      <ul className="tlw-flex tlw-gap-9 tlw-overflow-hidden">
        {totalCategories.map((item) => (
          <li key={item.title}>
            <CategoryLink category={item} />
          </li>
        ))}
      </ul>
    </nav>
  );
}
